export enum ReferralPaymentStatus {
  PROCESSED = 'PROCESSED',
  ACTUAL = 'ACTUAL',
  ARCHIVE = 'ARCHIVE',
}

export enum ReferralPaymentPayRollStatus {
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  NOT_PROCESSED = 'NOT_PROCESSED',
}
